import { AccountProfile } from '@core/swagger-client';

export const ProfileName = ({ profile }: { profile: AccountProfile }) => {
    let name = '';
    if (profile) {
        if (profile.firstName) {
            name = profile.firstName;
        }
        if (profile.lastName) {
            if (name) {
                name += ' ';
            }
            name += profile.lastName;
        }
        if (!name && profile.nickname) {
            name = profile.nickname;
        }
    }

    return <>{name}</>;
};
